import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthenticationStore } from '@argo/authentication';
import {
  ScaModuleTitleComponent,
  ScaAlertComponent,
  ScaIconComponent,
  ScaButtonComponent,
  ScaBadgeComponent
} from '@argo-dev-components-sca-angular/dev-components-sca';

@Component({
  selector: 'app-protected-with-roles',
  standalone: true,
  imports: [
    CommonModule,
    ScaModuleTitleComponent,
    ScaAlertComponent,
    ScaIconComponent,
    ScaButtonComponent,
    ScaBadgeComponent
  ],
  template: `
    <div style="padding: 2rem; max-width: 900px; margin: 0 auto;">
      <sca-module-title
        title="Acceso con verificación de roles"
        subtitle="Esta ruta requiere roles específicos"
        icon="admin_panel_settings">
      </sca-module-title>

      <sca-alert variant="success" style="margin-bottom: 1.5rem;">
        <sca-icon icon="verified_user" size="24px" left />
        Esta ruta está protegida por <code>authGuardCanMatchFn</code>
      </sca-alert>

      <div scaCardWorkshop>
        <div scaCardWorkshopHeader>
          <sca-icon icon="badge" size="32px" />
          <h2 scaCardWorkshopTitle>Información de Roles</h2>
        </div>
        <div scaCardWorkshopBody>
          <table class="info-table">
            <tr>
              <td><strong>Roles requeridos:</strong></td>
              <td>
                <sca-badge style="margin-right: 0.5rem;">ADMIN</sca-badge>
                <sca-badge>USER</sca-badge>
              </td>
            </tr>
            <tr>
              <td><strong>Tus roles:</strong></td>
              <td>
                @for (role of auth.getUserRoles(); track role) {
                  <sca-badge style="margin-right: 0.5rem;">{{ role }}</sca-badge>
                } @empty {
                  <span class="value-null">Sin roles</span>
                }
              </td>
            </tr>
            <tr>
              <td><strong>Usuario:</strong></td>
              <td><code>{{ auth.user().preferred_username || auth.user().email || 'N/A' }}</code></td>
            </tr>
            <tr>
              <td><strong>Guard utilizado:</strong></td>
              <td><code>authGuardCanMatchFn</code></td>
            </tr>
          </table>
        </div>
      </div>

      <div scaCardWorkshop style="margin-top: 1.5rem;">
        <div scaCardWorkshopHeader>
          <sca-icon icon="code" size="32px" />
          <h3 scaCardWorkshopTitle>Configuración del Guard</h3>
        </div>
        <div scaCardWorkshopBody>
          <pre style="background: #f5f5f5; padding: 1rem; border-radius: 4px; overflow-x: auto;">{{ guardConfig }}</pre>
        </div>
        <div scaCardWorkshopFooter>
          <button sca-button (click)="goBack()">
            <sca-icon icon="arrow_back" size="20px" left />
            Volver a Auth Test
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .info-table {
      width: 100%;
      border-collapse: collapse;
    }

    .info-table td {
      padding: 0.75rem;
      border-bottom: 1px solid #eee;
    }

    .info-table td:first-child {
      width: 40%;
      font-weight: 500;
    }

    .info-table tr:last-child td {
      border-bottom: none;
    }

    .value-null {
      color: #999;
      font-style: italic;
    }
  `]
})
export class ProtectedWithRolesComponent {
  readonly auth = inject(AuthenticationStore);
  private router = inject(Router);

  readonly guardConfig = `{
  path: 'protected-roles',
  component: ProtectedWithRolesComponent,
  canMatch: [authGuardCanMatchFn],
  data: {
    authGuard: {
      requireAuthentication: true,
      requiredRoles: ['ADMIN', 'USER']
    }
  }
}`;

  goBack() {
    this.router.navigate(['/test/auth']);
  }
}
